import React from 'react';
import PropTypes from 'prop-types';
import parse from "html-react-parser"
import './style.scss';

import IconHexagon from '@learningblocks/exp-constants/lib/Icons/hexagon-solid'

export class SummaryText extends React.Component {
  render() {
    return(
      <div className={this.props.className}>
        <h5 tabIndex={0}>{this.props.heading}</h5>
        <ul style={{marginTop: (this.props.heading)?16:0}}>
          {this.props.items.map((item, index)=>{
            return(
              <li>
                <div className="index">
                  <IconHexagon
                    style={{ fill: "#003E6B", height: '18px' }}
                  />
                </div>
                <span tabIndex={0}>{parse(item)}</span>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}
SummaryText.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  items: PropTypes.array.isRequired,
  heading: PropTypes.string.isRequired,
  className: PropTypes.string,
};

SummaryText.defaultProps = {
  className: 'summaryText',
};
